<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Loan Information</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<table>
					<tr>
						<td style="width: 150px">Loan amount</td>
						<td style="width: 40px">:</td>
						<td>{{config.moneylify(loan.amount)}}</td>
					</tr>
					<tr>
						<td>Loan term</td>
						<td>:</td>
						<td>{{loan.term}} Months</td>
					</tr>
					<tr>
						<td>Interest rate</td>
						<td>:</td>
						<td>{{loan.interest_rate}}%</td>
					</tr>
					<tr>
						<td>Total interest</td>
						<td>:</td>
						<td>{{config.moneylify(loan.interest_amount)}}</td>
					</tr>
					<tr>
						<td>Loan fee</td>
						<td>:</td>
						<td>{{config.moneylify(loan.loan_fee)}}</td>
					</tr>
					<tr>
						<td>Total payment</td>
						<td>:</td>
						<td><b>{{config.moneylify(loan.total_payment)}}</b></td>
					</tr>
					<tr>
						<td>Status</td>
						<td>:</td>
						<td>
							<span class="active" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
							<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
						</td>
					</tr>

				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<table style="border-width: 0px;">
					<tr>
						<td>Client</td>
						<td>:</td>
						<td>{{loan.name}}</td>
					</tr>
					<tr>
						<td style="width: 150px">Initial payment</td>
						<td style="width:40px">:</td>
						<td>{{config.moneylify(loan.initial_payment)}}</td>
					</tr>
					<tr>
						<td>Monthly payment</td>
						<td>:</td>
						<td>{{config.moneylify(loan.monthly_payment)}}</td>
					</tr>
					<tr>
						<td>Final payment</td>
						<td>:</td>
						<td>{{config.moneylify(loan.final_payment)}}</td>
					</tr>
					<tr>
						<td>Paid EMIs</td>
						<td>:</td>
						<td>{{loan.total_paid}} / {{loan.term}}</td>
					</tr>
					<!-- <tr>
					<td>Remaining balance</td>
					<td>:</td>
					<td>{{config.moneylify(loan.loan_balance)}}</td>
				</tr> -->
					<tr>
						<td>Loan period</td>
						<td>:</td>
						<td>{{config.datelify(loan.start_date)}} - {{config.datelify(loan.end_date)}}</td>
					</tr>
					<tr>
						<td>Next payment</td>
						<td>:</td>
						<td>
							<span v-if="loan.total_paid == loan.term">N/A</span>
							<span class="active" v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}}</span>
						</td>
						<!-- <td><span class="late" v-if="false">12/11/2021</span></td> -->
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Loan Remark</h3>
				<p v-if="String(loan.note).length > 0">{{loan.note}}</p>
				<p v-else>Not available</p>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Payment History</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="paymentList.length > 0">
					<md-table-row>
						<md-table-head>Term</md-table-head>
						<md-table-head>Payment ID</md-table-head>
						<md-table-head>Payment Date</md-table-head>
						<md-table-head>Principal</md-table-head>
						<md-table-head>Interest</md-table-head>
						<md-table-head>Total</md-table-head>
						<md-table-head>Balance</md-table-head>
						<md-table-head>Status</md-table-head>
						<md-table-head>Action</md-table-head>
					</md-table-row>

					<md-table-row v-for="(payment, index) in paymentList">
						<md-table-cell>{{ payment.term_id }}</md-table-cell>
						<md-table-cell>{{ payment.hash_id }}</md-table-cell>
						<md-table-cell>{{ config.datelify(payment.created_date) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
						<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal)}}</b></md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.balance) }}</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="payment.status == 'pnd'">{{ config.getStatus(payment.status) }}</span>
							<span class="active" v-if="payment.status == 'pad'">{{ config.getStatus(payment.status) }}</span>
						</md-table-cell>
						<md-table-cell>
							<md-button class="md-just-icon md-simple md-primary" v-if="payment.status=='pnd'"
								@click="payPayment(payment.id)">
								<md-icon>price_check</md-icon>
								<md-tooltip md-direction="top">Pay</md-tooltip>
							</md-button>
							<span v-else>{{config.datelify(payment.paid_date)}}</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-size-100 text-right" v-if="loan.status != 'fin'">
				<md-button class="md-raised md-primary" @click="">
					Pay All</md-button>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="payDialog" md-title="Are you sure want to mark this as paid ?"
			md-content="" md-confirm-text="OK" md-cancel-text="Cancel"
			@md-cancel="onCancel" @md-confirm="payPayment" />
	</div>
</template>
<script>
	export default {
		created() {
			this.getLoan();
			this.getPayment();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				payDialog: false,
				payID: "",
				loan: {
					id: "",
					hash_id: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					name: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash_id).then(data => {
					this.loan = data.body.data
					this.loaded = true
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/admin/loan/get_payment/" + this.$route.params.hash_id).then(data => {
					this.paymentList = data.body.data
				})
			},
			payPayment(id = "") {
				if (id == "" && String(this.payID).length > 0) {
					this.$http.post(this.config.api + "/admin/loan/pay/payment", {
						payment_id: this.payID,
						loan_id: this.loan.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getLoan();
						}
					})
				} else {
					this.payID = id;
					this.payDialog = true;
				}

			},
			onCancel() {
				this.payDialog = false;
				this.payID = "";
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Approvals/Detail.vue